export enum PaymentTypeEnum {
    invoice = 'invoice',
    creditCard = 'credit-card',
    ach = 'ACH',
    free = 'free',
    paymentPlan = 'payment-plans'
}
